import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'type',
    label: 'Closing in Trust Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'establishedDate',
    label: 'Trust Established Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'name',
    label: 'Trust Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'establishedState',
    label: 'Trust Established State',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const trustForm = {
  name: FormNames.TITLE_HOLDER_GENERAL,
  label: 'Trust',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
